export default "__VITE_ASSET__DKAfAuhY__"